<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.detail_order"
          @keydown.esc="dialog.detail_order = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Food Order
              </div>

              <v-spacer/>

              <div
                class="body-2 primary--text mr-4">
                {{ detail_order.datetime | date }} - {{ detail_order.datetime | time }}
              </div>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail_order = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4">
                  <v-card
                    flat
                    color="#EDEDED"
                    class="text-h2 font-weight-bold d-flex align-center justify-center"
                    style="border: 1px solid #D8D8D8; border-radius: 8px; padding: 23px;">
                    <div
                      style="opacity: 90%;">
                      {{ detail_order.room_number }}
                    </div>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="8">
                  <v-card
                    flat
                    color="#F9F9F9"
                    style="border: 1px solid #D8D8D8; border-radius: 8px;">
                    <div
                      class="d-flex align-center">
                      <div
                        style="border-right: 1px solid #D8D8D8; width: 40%;">
                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Customer
                        </v-card>

                        <v-divider
                         style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Phone
                        </v-card>
                      </div>

                      <div
                        style="width: 60%;">
                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_order.guest_name }}
                        </v-card>

                        <v-divider
                         style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_order.guest_phone_number }}
                        </v-card>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left body-2 font-weight-bold"
                        style="border: none !important;">
                        Order
                      </th>
                      <th class="text-left body-2 font-weight-bold"
                        style="border: none !important;">
                        Qty
                      </th>
                      <th class="text-right body-2 font-weight-bold"
                        style="border: none !important;">
                        Sub Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in detail_order.detail_order"
                      :key="index"
                      style="opacity: 70%;">
                      <td style="border: none !important;">{{ item.menu_name }}</td>
                      <td style="border: none !important;">{{ item.qty }} x {{ item.price | price }}</td>
                      <td style="border: none !important;" class="text-right">{{ item.subtotal | price }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div
                class="body-1 font-weight-bold text-right pa-4">
                {{ detail_order.total_bill | price }}
              </div>

              <div v-if="message.error.length > 0"
                class="text-center my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <div
                class="body-2 line-text-second"
                style="width: 200px;">
                Accepted order will auto billed to customer
              </div>

              <v-spacer/>

              <v-btn
                @click="save_accept_order()"
                :loading="process.accept"
                :disabled="process.accept || process.void"
                width="100"
                elevation="0"
                :color="set_color"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Accept
              </v-btn>

              <v-btn
                @click="save_void_order()"
                :loading="process.void"
                :disabled="process.void || process.accept"
                width="100"
                elevation="0"
                color="#C03E3A"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Void
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail_service"
          @keydown.esc="dialog.detail_service = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Services Request
              </div>

              <v-spacer/>

              <div
                class="body-2 primary--text mr-4">
                {{ detail_service.datetime | date }} - {{ detail_service.datetime | time }}
              </div>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail_service = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4">
                  <v-card
                    flat
                    color="#EDEDED"
                    class="text-h2 font-weight-bold d-flex align-center justify-center"
                    style="border: 1px solid #D8D8D8; border-radius: 8px; padding: 23px;">
                    <div
                      style="opacity: 90%;">
                      {{ detail_service.room_number }}
                    </div>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="8">
                  <v-card
                    flat
                    color="#F9F9F9"
                    style="border: 1px solid #D8D8D8; border-radius: 8px;">
                    <div
                      class="d-flex align-center">
                      <div
                        style="border-right: 1px solid #D8D8D8; width: 40%;">
                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Customer
                        </v-card>

                        <v-divider
                         style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="#EDEDED"
                          class="body-2 font-weight-bold pa-4"
                          style="opacity: 70%;">
                          Phone
                        </v-card>
                      </div>

                      <div
                        style="width: 60%;">
                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_service.guest_name }}
                        </v-card>

                        <v-divider
                         style="border-top: 1px solid #D8D8D8;"/>

                        <v-card
                          flat
                          color="transparent"
                          class="body-2 pa-4"
                          style="opacity: 70%;">
                          {{ detail_service.guest_phone_number }}
                        </v-card>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <div
                class="body-1 font-weight-bold mt-4 mb-3">
                Request
              </div>

              <v-card
                flat
                color="#F9F9F9"
                class="mb-4"
                style="border: 1px solid #D8D8D8; border-radius: 8px;">
                <div
                  class="d-flex align-center">
                  <div
                    style="border-right: 1px solid #D8D8D8; width: 40%;">
                    <v-card
                      flat
                      color="#EDEDED"
                      class="body-2 font-weight-bold pa-4"
                      style="opacity: 70%;">
                      Room Service
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="#EDEDED"
                      class="body-2 font-weight-bold pa-4"
                      style="opacity: 70%;">
                      Engineering
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="#EDEDED"
                      class="body-2 font-weight-bold pa-4"
                      style="opacity: 70%;">
                      Bell Boy
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="#EDEDED"
                      class="body-2 font-weight-bold pa-4"
                      style="opacity: 70%;">
                      Wake up Time
                    </v-card>
                  </div>

                  <div
                    style="width: 60%;">
                    <v-card
                      flat
                      color="transparent"
                      class="body-2 pa-4"
                      style="opacity: 70%;">
                      {{ detail_service.type === 'ROOM_SERVICE' ? detail_service.detail : '-' }}
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="transparent"
                      class="body-2 pa-4"
                      style="opacity: 70%;">
                      {{ detail_service.type === 'ENGINEERING' ? detail_service.detail : '-' }}
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="transparent"
                      class="body-2 pa-4"
                      style="opacity: 70%;">
                      {{ detail_service.type === 'BELL_BOY' ? detail_service.detail : '-' }}
                    </v-card>

                    <v-divider
                      style="border-top: 1px solid #D8D8D8;"/>

                    <v-card
                      flat
                      color="transparent"
                      class="body-2 pa-4"
                      style="opacity: 70%;">
                      {{ detail_service.type === 'WAKE_UP_CALL' ? detail_service.wake_up_time : '-' }}
                    </v-card>
                  </div>
                </div>
              </v-card>

              <div v-if="message.error.length > 0"
                class="text-center my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <div
                class="body-2 line-text-second"
                style="width: 200px;">
                Accepted order will notified to customer
              </div>

              <v-spacer/>

              <v-btn
                @click="save_accept_service()"
                :loading="process.accept"
                :disabled="process.accept || process.void"
                width="100"
                elevation="0"
                :color="set_color"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Accept
              </v-btn>

              <v-btn
                @click="save_void_service()"
                :loading="process.void"
                :disabled="process.void || process.accept"
                width="100"
                elevation="0"
                color="#C03E3A"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Void
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      {{ app_name }}
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <div
                      class="body-2"
                      style="font-weight: 600; color: #4B5563;">
                      {{ date_now | date }} | {{ date_now | time }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row
                    align="center">
                    <v-col
                      cols="12"
                      md="11"
                      class="py-0">
                      <div
                        class="body-2 line-text-second"
                        style="color: #4B5563;">
                        <v-skeleton-loader
                          v-for="(item, index) in process.load ? 1 : 1"
                          :key="index"
                          :loading="process.load"
                          type="list-item-two-line">
                          <template>
                            <div>
                              {{ running_text_json.text }}
                            </div>
                          </template>
                        </v-skeleton-loader>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="1"
                      class="text-right py-0">
                      <v-btn
                        to="/text"
                        color="#4B4B4B"
                        elevation="0"
                        class="body-2 white--text text-capitalize"
                        style="border-radius: 8px; font-weight: 600;">
                        Edit
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              v-for="(item, index) in process.summary ? 6 : list.summary"
              :key="index"
              cols="12"
              md="2">
              <v-skeleton-loader
                :key="index"
                :loading="process.summary"
                type="list-item-avatar-two-line">
                <template>
                  <div>
                    <v-card v-if="!process.summary && list.summary.length > 0"
                      flat
                      style="border-radius: 10px; border: 1px solid #E7E7E7;">
                      <v-card-text
                        class="d-flex align-center">
                        <v-avatar
                          tile
                          size="20"
                          :color="item.color"
                          style="border-radius: 3px !important;">
                        </v-avatar>

                        <span
                          class="body-2 ml-2"
                          style="color: #4B5563;">
                          {{ item.text }}
                        </span>
                      </v-card-text>

                      <v-card-text
                        class="title"
                        style="font-weight: 600; color: #4B5563;">
                        <span v-if="index < 2">
                          {{ item.value | price }}
                        </span>

                        <span v-else>
                          {{ item.value }}
                        </span>
                      </v-card-text>
                    </v-card>
                  </div>
                </template>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="4">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="body-1"
                  style="font-weight: 600; color: #4B5563;">
                  Today Food Order
                </v-card-text>

                <v-divider
                  style="border-top: 1px solid #E7E7E7;" />

                <v-data-table
                  ref="table-grid"
                  class="table-grid"
                  height="calc(100vh - 482px)"
                  :show-select="false"
                  :single-select="true"
                  :headers="headers.order"
                  :items="list.order"
                  :loading="process.order"
                  @click:row="fetchDetailOrder"
                  loading-text="Loading . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  hide-default-header
                  hide-default-footer>
                  <template v-slot:item.guest_name="{ item }">
                    <div
                      class="primary--text">
                      {{ item.guest_name }}
                    </div>
                  </template>

                  <template v-slot:item.total_bill="{ item }">
                    <div>
                      {{ item.total_bill | price }}
                    </div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      small
                      rounded
                      :color="item.status === 'waiting' ? 'yellow' : item.status === 'declined' ? 'red' : set_color"
                      elevation="0"
                      class="text-capitalize mx-1"
                      :class="item.status === 'waiting' ? '' : 'white--text'"
                      style="font-weight: 600;">
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="5">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="body-1"
                  style="font-weight: 600; color: #4B5563;">
                  Today Hotel Services
                </v-card-text>

                <v-divider
                  style="border-top: 1px solid #E7E7E7;" />

                <v-data-table
                  ref="table-grid"
                  class="table-grid"
                  height="calc(100vh - 482px)"
                  :show-select="false"
                  :single-select="true"
                  :headers="headers.service"
                  :items="list.service"
                  :loading="process.service"
                  @click:row="fetchDetailService"
                  loading-text="Loading . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  hide-default-header
                  hide-default-footer>
                  <template v-slot:item.guest_name="{ item }">
                    <div
                      class="primary--text">
                      {{ item.guest_name }}
                    </div>
                  </template>

                  <template v-slot:item.wake_up_time="{ item }">
                    <div v-if="item.wake_up_time !== ''">
                      {{ item.wake_up_time.split(':')[0] }}:{{ item.wake_up_time.split(':')[1] }}
                    </div>

                    <div v-else>
                      -
                    </div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      small
                      rounded
                      :color="item.status === 'waiting' ? 'yellow' : item.status === 'declined' ? 'red' : set_color"
                      elevation="0"
                      class="text-capitalize mx-1"
                      :class="item.status === 'waiting' ? '' : 'white--text'"
                      style="font-weight: 600;">
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="3">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="body-1"
                  style="font-weight: 600; color: #4B5563;">
                  Guest Check in
                </v-card-text>

                <v-divider
                  style="border-top: 1px solid #E7E7E7;" />

                <v-list 
                  flat
                  class="pa-0"
                  style="height: calc(100vh - 482px); overflow-y: auto;">
                  <v-skeleton-loader
                    v-for="(item, index) in process.guest ? 4 : list.guest"
                    :key="index"
                    :loading="process.guest"
                    type="list-item-two-line">
                    <template>
                      <div>
                        <v-list-item v-if="!process.guest && list.guest.length > 0"
                          :to="`/guest/${item.id}`"
                          :style="index < list.guest.length - 1 ? 'border-bottom: 1px solid #F4F4F4;' : ''">
                          <v-list-item-content>
                            <div
                              class="body-2 primary--text"
                              style="margin-bottom: 6px;">
                              {{ item.guest_name }}
                            </div>

                            <div
                              class="body-2 black--text"
                              style="opacity: 60%;">
                              {{ item.number }}
                            </div>
                          </v-list-item-content>

                          <v-list-item-action>
                            <div
                              class="body-2 green--text"
                              style="margin-bottom: 6px;">
                              {{ item.guest_checkin_datetime | date }}
                            </div>

                            <div
                              class="body-2 red--text">
                              {{ item.guest_checkout_datetime | date }}
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                      </div>
                    </template>
                  </v-skeleton-loader>

                  <div v-if="!process.guest && list.guest.length < 1"
                    class="body-2 font-weight-light text-center my-2"
                    style="opacity: 45%;">
                    No data available
                  </div>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        date_now: new Date(),

        dialog: {
          fullscreen: false,
          detail_order: false,
          detail_service: false
        },

        app_name: 'Visuality',
        running_text_json: '',

        detail_order: {},
        detail_service: {},

        headers: {
          order: [],
          service: []
        },

        list: {
          summary: [],
          order: [],
          service: [],
          guest: []
        },

        pagination: {
          order: {}
        },

        process: {
          load: false,
          summary: false,
          order: false,
          service: false,
          guest: false,

          accept: false,
          void: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchText()
        this.fetchName()
        this.fetchSummary()
        this.fetchOrder()
        this.fetchService()
        this.fetchGuest()
      },

      async fetchText () {
        this.process.load = true

        let params = {
          key: 'RUNNING_TEXT_JSON'
        }

        await get(`admin/config/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.running_text_json = res.result.data.RUNNING_TEXT_JSON.value_object
          }
        })
      },
      async fetchName () {
        this.process.load = true

        let params = {
          key: 'APP_NAME'
        }

        await get(`admin/config/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.app_name = res.result.data.APP_NAME.value
          }
        })
      },
      async fetchSummary () {
        this.process.summary = true

        await get(`admin/dashboard/summary`)
        .then(response => {
          let res = response.data

          this.process.summary = false
            
          if (res.code === 200) {
            let item = res.result

            this.list.summary = [
              {
                text: 'Today Transaction',
                value: item.today_transaction,
                color: '#0884BB'
              },
              {
                text: 'Total Bill',
                value: item.total_bill,
                color: '#BD006B'
              },
              {
                text: 'Total Service Request',
                value: item.total_service_request,
                color: '#348A16'
              },
              {
                text: 'Total Food Order',
                value: item.total_food_order,
                color: '#C77904'
              },
              {
                text: 'Total Guest',
                value: item.total_guest,
                color: '#413E3E'
              },
              {
                text: 'Total Room',
                value: item.total_room,
                color: '#FFEC25'
              }
            ]
          }
        })
      },
      async fetchOrder () {
        this.process.order = true

        await get(`admin/dashboard/today-food-order`)
        .then(response => {
          let res = response.data

          this.process.order = false
            
          if (res.code === 200) {
            this.headers.order = [
              {
                text: 'Name',
                width: '200px',
                value: 'guest_name'
              },
              {
                text: 'Room',
                width: '100px',
                value: 'room_number'
              },
              {
                text: 'Total Bill',
                width: '200px',
                value: 'total_bill'
              },
              {
                text: 'Status',
                width: '100px',
                value: 'status'
              }
            ]

            this.list.order = res.result.data
            this.pagination.order = res.result.meta
          }
        })
      },
      async fetchService () {
        this.process.service = true

        await get(`admin/dashboard/today-service-request`)
        .then(response => {
          let res = response.data

          this.process.service = false
            
          if (res.code === 200) {
            this.headers.service = [
              {
                text: 'Name',
                width: '200px',
                value: 'guest_name'
              },
              {
                text: 'Time',
                width: '100px',
                value: 'wake_up_time'
              },
              {
                text: 'Room',
                width: '100px',
                value: 'room_number'
              },
              {
                text: 'Service',
                width: '200px',
                value: 'service_title'
              },
              {
                text: 'Status',
                width: '100px',
                value: 'status'
              }
            ]

            this.list.service = res.result.data
            this.pagination.service = res.result.meta
          }
        })
      },
      async fetchGuest () {
        this.process.guest = true

        await get(`admin/dashboard/guest-checkin`)
        .then(response => {
          let res = response.data

          this.process.guest = false
            
          if (res.code === 200) {
            this.list.guest = res.result.data
            this.pagination.guest = res.result.meta
          }
        })
      },

      async fetchDetailOrder (item, row) {
        let params = {
          id: item.id
        }

        await get(`admin/food-order/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.detail_order = res.result

            this.dialog.detail_order = true
          }
        })
      },
      async save_accept_order () {
        this.message.error = ''

        this.process.accept = true

        // SAVE TO REST API
        await post(`admin/food-order/accept`, {
          data: {
            id: this.detail_order.id
          }
        })
        .then((response) => {
          let res = response.data

          this.process.accept = false

          if (res.code === 200) {
            this.dialog.detail_order = false

            this.fetchOrder()
          } else {
            this.message.error = res.message
          }
        })
      },
      async save_void_order () {
        this.message.error = ''

        this.process.void = true

        // SAVE TO REST API
        await post(`admin/food-order/cancel`, {
          data: {
            id: this.detail_order.id
          }
        })
        .then((response) => {
          let res = response.data

          this.process.void = false

          if (res.code === 200) {
            this.dialog.detail_order = false

            this.fetchOrder()
          } else {
            this.message.error = res.message
          }
        })
      },

      async fetchDetailService (item, row) {
        let params = {
          id: item.id
        }

        await get(`admin/service-request/detail`, { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.detail_service = res.result

            this.dialog.detail_service = true
          }
        })
      },
      async save_accept_service () {
        this.message.error = ''

        this.process.accept = true

        // SAVE TO REST API
        await post(`admin/service-request/accept`, {
          data: {
            id: this.detail_service.id
          }
        })
        .then((response) => {
          let res = response.data

          this.process.accept = false

          if (res.code === 200) {
            this.dialog.detail_service = false

            this.fetchService()
          } else {
            this.message.error = res.message
          }
        })
      },
      async save_void_service () {
        this.message.error = ''

        this.process.void = true

        // SAVE TO REST API
        await post(`admin/service-request/decline`, {
          data: {
            id: this.detail_service.id
          }
        })
        .then((response) => {
          let res = response.data

          this.process.void = false

          if (res.code === 200) {
            this.dialog.detail_service = false

            this.fetchService()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>